import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ContainerState } from './types';

export const initialState: ContainerState = {
  myautoiqSegmentSettings: { data: null, loading: false, error: null },
};

const myautoiqSegmentSettingsSlice = createSlice({
  name: 'myautoiqSegmentSettingsComponentState',
  initialState,
  reducers: {
    requestMyautoiqSegmentSettings(state, action: PayloadAction<any>) {
      state.myautoiqSegmentSettings.loading = true;
      state.myautoiqSegmentSettings.error = null;
    },
    requestMyautoiqSegmentSettingsSuccess(state, action: PayloadAction<any>) {
      state.myautoiqSegmentSettings.data = action.payload;
      state.myautoiqSegmentSettings.loading = false;
    },
    requestMyautoiqSegmentSettingsError(state, action: PayloadAction<any>) {
      state.myautoiqSegmentSettings.error = action.payload;
      state.myautoiqSegmentSettings.loading = false;
    },
    requestUpdateMyautoiqSegmentSettings(state, action: PayloadAction<any>) {
      state.myautoiqSegmentSettings.loading = true;
      state.myautoiqSegmentSettings.error = null;
    },
    requestUpdateMyautoiqSegmentSettingsSuccess(state) {
      state.myautoiqSegmentSettings.loading = false;
    },
    requestUpdateMyautoiqSegmentSettingsError(state, action: PayloadAction<any>) {
      state.myautoiqSegmentSettings.error = action.payload;
      state.myautoiqSegmentSettings.loading = false;
    },
    requestCreateMyautoiqSegmentSettings(state, action: PayloadAction<any>) {
      state.myautoiqSegmentSettings.loading = true;
      state.myautoiqSegmentSettings.error = null;
    },
    requestCreateMyautoiqSegmentSettingsSuccess(state) {
      state.myautoiqSegmentSettings.loading = false;
    },
    requestCreateMyautoiqSegmentSettingsError(state, action: PayloadAction<any>) {
      state.myautoiqSegmentSettings.error = action.payload;
      state.myautoiqSegmentSettings.loading = false;
    },
  },
});

export const {
  actions: myautoiqSegmentSettingsActions,
  reducer,
  name: sliceKey,
} = myautoiqSegmentSettingsSlice;
